import { Component, computed, input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PasswordValidator } from '@shared/models/password.model';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-pass-form',
  imports: [FormsModule, SharedModule],
  templateUrl: './pass-form.component.html',
})
export class PassFormComponent {
  send = output<string>();
  isSending = input(false);
  isReset = input(false);
  validations = computed(() => this.validate(this.password(), this.passwordCheck()));
  password = signal('');
  passwordCheck = signal('');
  passwordType = computed(() => (this.showPassword() ? 'text' : 'password'));
  showPassword = signal(false);

  onSubmit() {
    if (this.validations().length) return;
    this.send.emit(this.password());
  }

  private validate(password: string, passwordCheck: string) {
    const validations: string[] = PasswordValidator.validateWithMessages(password);
    if (!passwordCheck || passwordCheck !== password) validations.push('Passwords should match');
    return validations;
  }
}
